export default "__VITE_ASSET__B18K8oUu__"